module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"frontmatter":{"path":"/zpracovani-mezd","title":"Zpracování mezd a personalistiky"}}},{"node":{"frontmatter":{"path":"/vedeni-ucetnictvi","title":"Vedení účetnictví"}}},{"node":{"frontmatter":{"path":"/kontakt","title":"Kontakt"}}},{"node":{"frontmatter":{"path":"/danove-poradenstvi","title":"Daňové poradenství"}}},{"node":{"frontmatter":{"path":"/aktuality","title":"Aktuality"}}}]}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 196
// module chunks = 60335399758886 114276838955818